import { imageResponse } from '../general';
import { EMarketingCenterColorSchemes } from './colorScheme';
export interface ICanvasElementDrawArgs {
  title: string;
  text: string;
  color: EMarketingCenterColorSchemes;
  brand: string;
  business: {
    name: string;
    logo: imageResponse;
  };
  canvas: {
    width: number;
    height: number;
  };
}

export interface ICanvasElement {
  draw(
    context: CanvasRenderingContext2D,
    args: ICanvasElementDrawArgs
  ): Promise<any>;

  render?(
    container: HTMLDivElement,
    context: CanvasRenderingContext2D,
    args: ICanvasElementDrawArgs
  ): void;

  showOnPreview: boolean;
}

export interface IPositionXY {
  x: number;
  y: number;
}

export interface IFontOption {
  family?: string;
  size?: number;
  lineHeight?: number;
  align?: CanvasTextAlign;
  weight?: string;
  color?: string;
  maxWidth?: number;
  numberOfLines?: number;
}

export interface ICanvasTextOptions {
  font?: IFontOption;
  position: IPositionXY;
  text?: string | ((args: ICanvasElementDrawArgs) => string);
}

export abstract class ACanvasTextElement implements ICanvasElement {
  public offsetTop: number = 0;
  public nextYCoordAvailble: number = 0;
  public renderOffsetTop: number = 0;
  public renderNextYCoordAvailble: number = 0;
  public showOnPreview = false;

  abstract draw(
    context: CanvasRenderingContext2D,
    args: ICanvasElementDrawArgs
  ): Promise<any>;

  abstract render(
    container: HTMLDivElement,
    context: CanvasRenderingContext2D,
    args: ICanvasElementDrawArgs
  ): void;

  abstract defaultValues: IFontOption;
}

export type TCanvasTextElement = new (
  options: ICanvasTextOptions
) => ACanvasTextElement;
